import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GpuToastService, GpuToastType } from '@geneplanet/ngx-ui';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, throwError } from 'rxjs';

@Injectable()
export class NoInternetInterceptor implements HttpInterceptor {
  private buttonClicked$ = new Subject<void>();

  constructor(
    private toastrService: GpuToastService,
    private translateService: TranslateService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!window.navigator.onLine) {
      const text = this.translateService.instant(
        'FAILURE.NO_INTERNET_TOAST.DESCRIPTION'
      );
      const buttonText = this.translateService.instant('FAILURE.RETRY');

      this.showMessage(text, buttonText);

      this.buttonClicked$.pipe().subscribe(() => {
        if (window.navigator.onLine) {
          window.location.reload();
        } else {
          this.showMessage(text, buttonText);
        }
      });

      return throwError(
        () => new HttpErrorResponse({ error: 'There is no internet' })
      );
    }

    return next.handle(request);
  }

  public showMessage(text: string, buttonText: string): void {
    this.toastrService.show({ text, buttonText }, GpuToastType.Error, {
      disableTimeout: true,
      buttonClicked$: this.buttonClicked$,
    });
  }
}
